import apiClient from './client';

export interface UserProfile {
  id: string;
  email: string;
  display_name: string;
  username?: string;
  location?: string;
  connection_type?: string;
  auth_provider: string;
  is_active: boolean;
  is_verified: boolean;
  email_verified: boolean;
  friend_code?: string;
  is_supporter: boolean;
  supporter_since?: string;
  supporter_until?: string;
  created_at: string;
  last_seen: string;
  location_visible: boolean;
  online_status_visible: boolean;
  sharing_enabled: boolean;
  max_concurrent_connections: number;
  bandwidth_limit_mbps?: number;
  daily_data_limit_gb?: number;
}

export interface UserUpdateRequest {
  display_name?: string;
  username?: string;
  location?: string;
  connection_type?: string;
  location_visible?: boolean;
  online_status_visible?: boolean;
  sharing_enabled?: boolean;
  max_concurrent_connections?: number;
  bandwidth_limit_mbps?: number;
  daily_data_limit_gb?: number;
}

export interface PasswordUpdateRequest {
  current_password: string;
  new_password: string;
}

export const usersApi = {
  getProfile: () =>
    apiClient.get<UserProfile>('/api/v1/users/profile'),

  updateProfile: (data: UserUpdateRequest) =>
    apiClient.put<UserProfile>('/api/v1/users/profile', data),

  updatePassword: (data: PasswordUpdateRequest) =>
    apiClient.put<{ message: string }>('/api/v1/users/password', data),

  deleteAccount: () =>
    apiClient.delete<{ message: string }>('/api/v1/users/account'),
};